import { render, staticRenderFns } from "./lyqc.vue?vue&type=template&id=69067e6d&scoped=true"
import script from "./lyqc.vue?vue&type=script&lang=js"
export * from "./lyqc.vue?vue&type=script&lang=js"
import style0 from "./lyqc.vue?vue&type=style&index=0&id=69067e6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69067e6d",
  null
  
)

export default component.exports